import { ref } from 'vue'

/**
 * Drives the "Confirm it's you" dialog. The API client calls `request()` on a
 * 423; the dialog resolves it with true (confirmed, retry the action) or
 * false (cancelled).
 */
const open = ref(false)
let resolver: ((confirmed: boolean) => void) | null = null

export function useReauth() {
  function request(): Promise<boolean> {
    if (resolver) resolver(false)
    open.value = true
    return new Promise((resolve) => {
      resolver = resolve
    })
  }

  function finish(confirmed: boolean): void {
    open.value = false
    resolver?.(confirmed)
    resolver = null
  }

  return { open, request, finish }
}
